import React from 'react';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import { VALIDATION } from 'helpers/constants';
import { useStore } from 'hooks';
import { ChangePasswordByAdmin } from 'components/profile';
import { AuthService } from 'services';
import * as Yup from 'yup';

const ChangePasswordByAdminValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(5, 'Пароль должен быть от 5 до 16 символов')
    .max(16, 'Пароль должен быть от 5 до 16 символов')
    .required(...VALIDATION.REQUIRED),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Пароли не совпадают')
    .required(...VALIDATION.REQUIRED),
});

const ChangePasswordByAdminColumn = ({ match: { params: { userId } } }) => {
  const { setLoading, setUser } = useStore();
  const initialValues = {
    password: '',
    confirmPassword: '',
  };

  const onSubmit = async (values) => {
    const authService = new AuthService({ setUser });
    setLoading(true);
    await authService.updatePasswordByAdmin({ ...values, userId });
    setLoading(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ChangePasswordByAdminValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, isValid }) => (
        <ChangePasswordByAdmin onSubmit={handleSubmit} isValid={isValid} />
      )}
    </Formik>
  );
};

export default withRouter(ChangePasswordByAdminColumn);
